let dismissLoadingScreen: (() => void) | null = null;

export function registerAppLoadingScreenDismiss(
  fn: (() => void) | null
): void {
  dismissLoadingScreen = fn;
}

export function dismissAppLoadingScreen(): void {
  dismissLoadingScreen?.();
}
